var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, useMemo, } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
import { footerStackAtSizes } from './constants';
import { ModalFooterContent, } from './ModalFooterContent';
const ModalFooterPrimary = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (_jsx(ModalFooterContent, Object.assign({}, props, { type: "primary" }, { children: children })));
};
const MemoizedModalFooterPrimary = memo(ModalFooterPrimary);
export { MemoizedModalFooterPrimary as ModalFooterPrimary };
const ModalFooterSecondary = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (_jsx(ModalFooterContent, Object.assign({}, props, { type: "secondary" }, { children: children })));
};
const MemoizedModalFooterSecondary = memo(ModalFooterSecondary);
export { MemoizedModalFooterSecondary as ModalFooterSecondary };
const defaultProps = {
    stackAt: footerStackAtSizes.small,
};
const ModalFooter = ({ children, stackAt = defaultProps.stackAt, }) => {
    const footerStyles = useMemo(() => (css `
        border-top: ${styleUtils.rem(1)} solid ${theme.colors.gray300};
        display: flex;
        flex-shrink: 0;
        flex-grow: 0;
        flex-wrap: wrap;
        flex-direction: row;
        padding-bottom: ${theme.spacing.x3};
        padding-left: ${theme.spacing.x6};
        padding-right: ${theme.spacing.x6};
        padding-top: ${theme.spacing.x3};
        ${theme.typeStyles.captionMediumStyles}
        text-transform: uppercase;

        ${stackAt !== 'none' && css `
          ${theme.media.lessThan(stackAt) `
            flex-direction: column-reverse;

            & > * {
              margin-bottom: ${theme.spacing.x3};
              width: 100%;
            }
          `}
        `}
      `), [
        stackAt,
    ]);
    return (_jsx("footer", Object.assign({ css: footerStyles }, { children: children })));
};
const MemoizedModalFooter = memo(ModalFooter);
export { MemoizedModalFooter as ModalFooter };
// MC-1068 Temporary hack for Storybook.
export default ModalFooter;
